import userApi from "../api/userApi"
import { timeOut } from '../utils/functions'

export function logInAction(auth) {
  return function(dispatch) {
    return userApi.login(auth).then(response => {
      localStorage.setItem("access_token", response.data.access_token);
      window.location.reload();
    }).catch(error => {
      dispatch(loginError(error.messages))
    });
  };
};

export function loginSuccess() {
  return { type: "LOGIN_SUCCESS" }
}

export function loginError(response) {
  return { type: "LOGIN_ERROR", response }
};

export function addUserAction(user, history) {
  return function(dispatch) {
    return userApi.addUser(user).then(response => {
      dispatch(addUserSuccess(response.data.description))
      history.push({pathname: '/'})
    }).catch(error => {
      dispatch(addUserFail(error.response.data.description));
    })
  }
};

function addUserSuccess(response) {
  return { type: "ADD_USER_SUCCESS", response}
}

function addUserFail(response) {
  return { type: "ADD_USER_FAIL", response}
}

export function recoverPasswordAction(auth, history) {
  return function(dispatch) {
    return userApi.recoverPassword(auth).then(response => {
      dispatch(recoverPasswordSuccess(response.data.description))
      history.push({pathname: '/'})
    }).catch(error => {
      dispatch(recoverPasswordFail(error.response.data.description));
    })
  }
}

function recoverPasswordSuccess(response) {
  return { type: "RECOVER_PASSWORD_SUCCESS", response}
}

function recoverPasswordFail(response) {
  return { type: "RECOVER_PASSWORD_FAIL", response}
}

export function changePasswordAction(auth) {
  return function(dispatch) {
    return userApi.changePassword(auth).then(response => {
      dispatch(changePasswordSuccess(response.data.description))
    }).catch(error => {
      dispatch(changePasswordFail(error.response.data.description));
    })
  }
}

function changePasswordSuccess(response) {
  return { type: "CHANGE_PASSWORD_SUCCESS", response}
}

function changePasswordFail(response) {
  return { type: "CHANGE_PASSWORD_FAIL", response}
}

export function getUserAction() {
  return function(dispatch) {
    return userApi.getUser().then(response => {
      dispatch(getUserSuccess(response.data))
    }).catch(error => {
      timeOut(error.response.status);
      dispatch(getUserFail(error.response.data))
    })
  }
}

function getUserSuccess(response) {
  return { type: 'GET_USER_SUCCESS', response }
}

function getUserFail(response) {
  return { type: 'GET_USER_ERROR', response }
}


